// extracted by mini-css-extract-plugin
export default {"comparisonName":"FilterName_comparisonName__ueQM3","active":"FilterName_active__Y3V5j"};